import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";

import drop from "../../../assets/images/icon_home/drop.svg";
import userweb from "../../../assets/images/icon_home/userweb.svg";
import messageweb from "../../../assets/images/icon_home/messageweb.svg";
import homeweb from "../../../assets/images/icon_home/homeweb.svg";
import stats from "../../../assets/images/icon_home/statsweb.svg";
import dot from "../../../assets/images/icon_home/dot-balance.svg";
import kanan from "../../../assets/images/icon_home/tangankanan.svg";
import kiri from "../../../assets/images/icon_home/tangankiri.svg";
import logo from "../../../assets/images/icon_home/logoweb.svg";
import notif from "../../../assets/images/icon_home/notif.svg";
import Navbar from "../Navbar";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../core/feature/hooks";
import User from "../../../core/models/user";
import { formatCurrency, showSvg } from "../../../config/global";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../core/feature/config/configSlice";
import Config from "../../../config/Config";
import CustomApp from "../../../core/models/customApp";
import { getNotifData } from "../../../core/service/api_notification";
import { getIconApps } from "../../../core/service/api";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Company from "../../../core/models/company";
import { isDarkColor } from "../../../config/DarkColorChecker";

export const Stats = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [statistics, setStatistics] = useState(null);
  const [data, setData] = useState<any>();
  const dispatch = useDispatch();
  const balance: Number = useAppSelector((state) => state.balance.balance);
  const user: User = useAppSelector((state) => state.user.user);
  const env = Config.BaseUrlDev;
  const [headerImg, setHeaderImg] = useState<any[]>([]);
  let company: any = JSON.parse(String(localStorage.getItem("company")));
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const getProfileImage = useMemo(() => {
    if (user?.photoUrl == "") {
      return userweb;
    }
    return env + "main_a/image/get/" + user?.photoUrl + "/pas";
  }, [user]);

  const getBalance = useMemo(() => formatCurrency(balance), [balance]);

  function getheaderImg() {
    let a: any = [];

    getIconApps(
      customApp?.company_id,
      customApp?.app_desktop_background_header_url
    ).then((res) => {
      a.push(showSvg(res.data));
    });

    setHeaderImg(a);
  }

  useEffect(() => {
    getheaderImg();
  }, []);

  return (
    <div id="stats">
      <div className="pb-20">
        <div
          className="flex flex-col w-full overflow-hidden"
          style={{
            backgroundColor: customApp?.app_accent_color
              ? customApp?.app_accent_color
              : "#453BD0",
          }}
        >
          <div className="flex w-full mx-auto h-32">
            <div className="mb-8 pt-8 w-1/3">
              {company?.customApps ? (
                <h1
                  className={`font-semibold text-base font-montserrat ml-8 
                  ${
                    isDarkColor(
                      customApp?.app_accent_color
                        ? customApp?.app_accent_color
                        : "#453BD0"
                    )
                      ? "text-white"
                      : "text-black"
                  }`}
                >
                  {customApp?.app_display_name}
                </h1>
              ) : (
                <img src={logo} alt="" className="h-8 lg:h-8 ml-8" />
              )}
            </div>
            <div className="mb-8 w-1/3">
              <Navbar
                item={"Home"}
                color={customApp?.app_accent_color}
                colorsecond={customApp?.app_secondary_accent_color}
              />
            </div>

            <div className="mb-8 pt-8 z-10 w-1/3">
              <div className="flex justify-end">
                <div
                  onClick={() => navigate("/profile")}
                  aria-label="Company"
                  title="Company"
                  className="inline-flex items-center cursor-pointer"
                >
                  <img
                    src={getProfileImage}
                    alt=""
                    className="w-10 h-10 object-cover rounded-full"
                  />
                </div>
              </div>
              {/* <ul className="flex justify-end mr-8">
                <li>
                  
                </li>
              </ul> */}
            </div>
          </div>
          <div className="flex z-10 justify-center flex-col items-center w-full h-1/2 md:w-64 md:h-48 lg:w-full lg:h-56 ">
            <LazyLoadImage
              src={headerImg.length < 0 ? drop : headerImg[0]}
              alt=""
              effect="blur"
              className="h-full min-h-[224px] min-w-[700px] lg:h-full w-full sm:w-auto self-center object-contain"
            />
          </div>
        </div>
        <div className="relative mx-auto w-36 container h-36 md:-mt-30 -mt-20 flex justify-between items-center bg-white flex-row  shadow rounded-2xl z-40">
          <div className="flex justify-center flex-col items-left w-full h-36 md:w-64 md:h-48 lg:w-full lg:h-56 pl-3.5">
            <p className="text-sm md:text-base lg:text-lg leading-none font-montserrat font-medium text-left text-gray-600">
              {t("TOPUP.balance")}
            </p>
            <h2 className="lg:text-3xl -mt-6 md:text-4xl text-2xl  leading-10 text-left font-montserrat font-bold text-gray-800">
              {getBalance}
            </h2>
            <button
              onClick={() => {
                navigate("/topup-history", {});
              }}
              style={{ backgroundColor: customApp?.app_secondary_accent_color }}
              className={`text-sm md:text-base lg:text-base w-fit px-3 py-2 leading-none text-left rounded-full
              ${
                isDarkColor(customApp?.app_secondary_accent_color)
                  ? "text-white"
                  : "text-black"
              }`}
            >
              {t("HOME.history")}
            </button>
          </div>
          <div className="pr-8">
            <img src={dot} className="h-48 w-48" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export const StatsMessage = () => {
  const navigate = useNavigate();
  const [pageI, setPageI] = useState(0);
  const [sizeI, setSizeI] = useState(10);
  const [totalI, setTotalI] = useState(0);
  const { t } = useTranslation();
  const [statistics, setStatistics] = useState(null);
  const [headerImg, setHeaderImg] = useState<any[]>([]);

  const balance: Number = useAppSelector((state) => state.balance.balance);
  const user: User = useAppSelector((state) => state.user.user);
  let company: any = JSON.parse(String(localStorage.getItem("company")));

  const getBalance = useMemo(() => formatCurrency(balance), [balance]);

  const env = Config.BaseUrlDev;

  const getProfileImage = useMemo(() => {
    if (user?.photoUrl == "") {
      return userweb;
    }
    return env + "main_a/image/get/" + user?.photoUrl + "/pas";
  }, [user]);

  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );

  useEffect(() => {
    // axios.get("https://teamhnm.org/api").then((res, err) => {
    //   setStatistics(res.data.data);
    // });
    getPesan();
  }, [statistics !== null]);

  function getheaderImg() {
    let a: any = [];

    getIconApps(
      customApp?.company_id,
      customApp?.app_desktop_background_header_url
    ).then((res) => {
      a.push(showSvg(res.data));
    });

    setHeaderImg(a);
  }

  useEffect(() => {
    getheaderImg();
  }, []);

  const getPesan = () => {
    getNotifData(pageI, sizeI)
      .then((res: any) => {
        console.log(res.data);
        setTotalI(res.data.totalElements);
        console.log(res.data.totalElements, "total pesan");
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  return (
    <div id="stats">
      <div className="pb-20 ">
        <div
          style={{
            backgroundColor: customApp?.app_accent_color
              ? customApp?.app_accent_color
              : "#453BD0",
          }}
          className="flex flex-col w-full overflow-hidden"
        >
          <div className="flex w-full justify-between mx-auto bg-gradient-to-l">
            <div className="mb-8 pt-8">
              {company?.customApps ? (
                <h1
                  className={`font-semibold text-base font-montserrat ml-8 ${
                    isDarkColor(customApp?.app_accent_color)
                      ? "text-white"
                      : "text-black"
                  }`}
                >
                  {customApp?.app_display_name}
                </h1>
              ) : (
                <img src={logo} alt="" className="h-8 lg:h-8 ml-8" />
              )}
            </div>
            <Navbar
              item={"Pesan"}
              color={customApp?.app_accent_color}
              colorsecond={customApp?.app_secondary_accent_color}
            />
            <div className="mb-8 pt-8 ">
              <ul className="flex justify-end mr-8">
                <li>
                  <div
                    onClick={() => navigate("/profile")}
                    aria-label="Company"
                    title="Company"
                    className="inline-flex items-center cursor-pointer"
                  >
                    <img
                      src={getProfileImage}
                      alt=""
                      className="w-10 h-10 object-cover rounded-full"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div
            className={`flex z-10 w-full h-1/2 md:w-64 md:h-48 lg:w-full lg:h-56 ${
              company?.customApps
                ? "justify-center items-center"
                : "justify-between"
            }`}
          >
            {!company?.customApps && (
              <img
                src={kiri}
                alt=""
                className="h-full mt-9 lg:h-full w-full sm:w-auto mb-6 object-contain"
              />
            )}
            <LazyLoadImage
              src={headerImg.length < 0 ? drop : headerImg[0]}
              alt=""
              effect="blur"
              className="h-full min-h-[224px] min-w-[700px] lg:h-full w-full sm:w-auto self-center object-contain"
            />
            {!company?.customApps && (
              <img
                src={kanan}
                alt=""
                className="h-full lg:h-full w-full sm:w-auto mb-6 object-contain"
              />
            )}
          </div>
          {/* ------ */}
          {/* <div className="mb-8 pt-8">
            {
              company?.customApps ? 
              <h1 className="font-semibold text-base text-white font-montserrat ml-8">
                {customApp?.app_display_name}
              </h1> : 
              <img src={logo} alt="" className="h-8 lg:h-8 ml-8" />
            }
            <img
              src={kiri}
              alt=""
              className="h-full mt-9 lg:h-full w-full sm:w-auto mb-6 object-contain"
            />
          </div>
          <Navbar
            item={"Pesan"}
            color={customApp?.app_accent_color}
            colorsecond={customApp?.app_secondary_accent_color}
            total={totalI}
          />
          <div className="mb-8 pt-8 ">
            <ul className="flex justify-end mr-8">              
              <li>
                <div
                  onClick={() => navigate("/profile")}
                  aria-label="Company"
                  title="Company"
                  className="inline-flex items-center cursor-pointer"
                >
                  <img
                    src={getProfileImage}
                    alt=""
                    className="w-10 h-10 object-cover rounded-full"
                  />
                </div>
              </li>
            </ul>
            <img
              src={kanan}
              alt=""
              className="h-full lg:h-full w-full sm:w-auto mb-6 object-contain"
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export function StatsProfil() {
  const [statistics, setStatistics] = useState(null);

  const navigate = useNavigate();
  const { t } = useTranslation();
  const [headerImg, setHeaderImg] = useState<any[]>([]);

  const env = Config.BaseUrlDev;
  const user: User = useAppSelector((state) => state.user.user);
  let company: any = JSON.parse(String(localStorage.getItem("company")));
  const getProfileImage = useMemo(() => {
    if (user?.photoUrl == "") {
      return userweb;
    }
    return env + "main_a/image/get/" + user?.photoUrl + "/pas";
  }, [user]);

  useEffect(() => {
    // axios.get("https://teamhnm.org/api").then((res, err) => {
    //   setStatistics(res.data.data);
    // });
  }, [statistics !== null]);

  function getheaderImg() {
    let a: any = [];

    getIconApps(
      customApp?.company_id,
      customApp?.app_desktop_background_header_url
    ).then((res) => {
      a.push(showSvg(res.data));
      setHeaderImg(a);
    });
  }

  useEffect(() => {
    getheaderImg();
  }, []);

  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  return (
    <div id="stats">
      <div className="">
        <div
          style={{
            backgroundColor: customApp?.app_accent_color
              ? customApp?.app_accent_color
              : "#453BD0",
          }}
          className="flex flex-col w-full overflow-hidden"
        >
          <div className="flex w-full justify-between mx-auto bg-gradient-to-l">
            <div className="mb-8 pt-8">
              {company?.customApps ? (
                <h1
                  className={`font-semibold text-base font-montserrat ml-8 ${
                    isDarkColor(customApp?.app_accent_color)
                      ? "text-white"
                      : "text-black"
                  }`}
                >
                  {customApp?.app_display_name}
                </h1>
              ) : (
                <img src={logo} alt="" className="h-8 lg:h-8 ml-8" />
              )}
            </div>
            <Navbar
              item={"Profile"}
              color={customApp?.app_accent_color}
              colorsecond={customApp?.app_secondary_accent_color}
            />
            <div className="mb-8 pt-8 ">
              <ul className="flex justify-end mr-8">
                <li>
                  <div
                    onClick={() => navigate("/profile")}
                    aria-label="Company"
                    title="Company"
                    className="inline-flex items-center cursor-pointer"
                  >
                    <img
                      src={getProfileImage}
                      alt=""
                      className="w-10 h-10 object-cover rounded-full"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div
            className={`flex w-full h-1/2 md:w-64 md:h-48 lg:w-full lg:h-56 ${
              company?.customApps
                ? "justify-center items-center"
                : "justify-between"
            }`}
          >
            {!company?.customApps && (
              <img
                src={kiri}
                alt=""
                className="h-full mt-9 lg:h-full w-full sm:w-auto mb-6 object-contain"
              />
            )}
            <LazyLoadImage
              src={headerImg.length < 0 ? drop : headerImg[0]}
              alt=""
              effect="blur"
              className="h-full min-h-[224px] min-w-[700px] lg:h-full w-full sm:w-auto self-center object-contain"
            />
            {!company?.customApps && (
              <img
                src={kanan}
                alt=""
                className="h-full lg:h-full w-full sm:w-auto mb-6 object-contain"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export function StatsTopup() {
  const navigate = useNavigate();
  const [statistics, setStatistics] = useState(null);

  const { t } = useTranslation();

  const balance: Number = useAppSelector((state) => state.balance.balance);

  const getBalance = useMemo(() => formatCurrency(balance), [balance]);
  let company: any = JSON.parse(String(localStorage.getItem("company")));

  const env = Config.BaseUrlDev;
  const user: User = useAppSelector((state) => state.user.user);
  const getProfileImage = useMemo(() => {
    if (user?.photoUrl == "") {
      return userweb;
    }
    return env + "main_a/image/get/" + user?.photoUrl + "/pas";
  }, [user]);

  useEffect(() => {
    // axios.get("https://teamhnm.org/api").then((res, err) => {
    //   setStatistics(res.data.data);
    // });
  }, [statistics !== null]);

  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  return (
    <div id="stats">
      <div className="pb-20 ">
        <div
          style={{
            backgroundColor: customApp?.app_accent_color
              ? customApp?.app_accent_color
              : "#453BD0",
          }}
          className="flex justify-between mx-auto bg-gradient-to-l h-80"
        >
          <div className="mb-8 pt-8">
            {company?.customApps ? (
              <h1
                className={`font-semibold text-base font-montserrat ml-8 ${
                  isDarkColor(customApp?.app_accent_color)
                    ? "text-white"
                    : "text-black"
                }`}
              >
                {customApp?.app_display_name}
              </h1>
            ) : (
              <img src={logo} alt="" className="h-8 lg:h-8 ml-8" />
            )}
            <img
              src={kiri}
              alt=""
              className="h-full mt-9 lg:h-full w-full sm:w-auto mb-6 object-contain"
            />
          </div>
          <Navbar
            item={"Home"}
            color={customApp?.app_accent_color}
            colorsecond={customApp?.app_secondary_accent_color}
          />
          <div className="mb-8 pt-8 ">
            <ul className="flex justify-end mr-8">
              {/* <li>
                <a
                  href="#"
                  aria-label="Home"
                  title="Home"
                  className="inline-flex items-center"
                >
                  <img src={notif} alt="" className="h-8 lg:h-8" />
                </a>
              </li> */}
              <li>
                <div
                  onClick={() => navigate("/profile")}
                  aria-label="Company"
                  title="Company"
                  className="inline-flex items-center cursor-pointer"
                >
                  <img
                    src={getProfileImage}
                    alt=""
                    className="w-10 h-10 object-cover rounded-full"
                  />
                </div>
              </li>
            </ul>
            <img
              src={kanan}
              alt=""
              className="h-full lg:h-full w-full sm:w-auto mb-6 object-contain"
            />
          </div>
        </div>
        <div className="mx-auto w-36 container h-36 md:-mt-30 -mt-20 flex justify-between items-center bg-white flex-row  shadow rounded-2xl">
          <div className="flex justify-center flex-col items-left w-full h-36 md:w-64 md:h-48 lg:w-full lg:h-56 pl-3.5">
            <p className="text-sm md:text-base lg:text-lg leading-none text-left text-gray-600">
              {t("HOME.balance")}
            </p>
            <h2 className="lg:text-3xl md:text-4xl text-2xl font-extrabold leading-10 text-left text-gray-800">
              {getBalance}
            </h2>
            <button
              onClick={() => {
                navigate("/topup-history", {});
              }}
              style={{ backgroundColor: customApp?.app_accent_color }}
              className=" text-sm md:text-base lg:text-base w-fit px-3 py-2 leading-none text-left text-white rounded-full "
            >
              {t("HOME.history")}
            </button>
          </div>
          <div className="pr-8">
            <img src={dot} className="h-48 w-48" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export function StatsInvoice() {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const [statistics, setStatistics] = useState();
  const [headerImg, setHeaderImg] = useState<any[]>([]);

  const env = Config.BaseUrlDev;
  const user: User = useAppSelector((state) => state.user.user);
  let company: any = JSON.parse(String(localStorage.getItem("company")));
  const getProfileImage = useMemo(() => {
    if (user?.photoUrl == "") {
      return userweb;
    }
    return env + "main_a/image/get/" + user?.photoUrl + "/pas";
  }, [user]);

  useEffect(() => {
    // axios.get("https://teamhnm.org/api").then((res, err) => {
    //   setStatistics(res.data.data);
    // });
  }, [statistics !== null]);

  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );

  function getheaderImg() {
    let a: any = [];

    getIconApps(
      customApp?.company_id,
      customApp?.app_desktop_background_header_url
    ).then((res) => {
      a.push(showSvg(res.data));
      setHeaderImg(a);
    });
  }

  useEffect(() => {
    getheaderImg();
  }, []);
  return (
    <div id="stats">
      <div className="pb-20">
        <div
          style={{
            backgroundColor: customApp?.app_accent_color
              ? customApp?.app_accent_color
              : "#453BD0",
          }}
          className="flex flex-col w-full overflow-hidden"
        >
          <div className="flex w-full justify-between mx-auto bg-gradient-to-l">
            <div className="mb-8 pt-8">
              {company?.customApps ? (
                <h1
                  className={`font-semibold text-base font-montserrat ml-8 ${
                    isDarkColor(customApp?.app_accent_color)
                      ? "text-white"
                      : "text-black"
                  }`}
                >
                  {customApp?.app_display_name}
                </h1>
              ) : (
                <img src={logo} alt="" className="h-8 lg:h-8 ml-8" />
              )}
            </div>
            <Navbar
              item={"Home"}
              color={customApp?.app_accent_color}
              colorsecond={customApp?.app_secondary_accent_color}
            />
            <div className="mb-8 pt-8 ">
              <ul className="flex justify-end mr-8">
                <li>
                  <div
                    onClick={() => navigate("/profile")}
                    aria-label="Company"
                    title="Company"
                    className="inline-flex items-center cursor-pointer"
                  >
                    <img
                      src={getProfileImage}
                      alt=""
                      className="w-10 h-10 object-cover rounded-full"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div
            className={`flex w-full h-1/2 md:w-64 md:h-48 lg:w-full lg:h-56 ${
              company?.customApps
                ? "justify-center items-center"
                : "justify-between"
            }`}
          >
            {!company?.customApps && (
              <img
                src={kiri}
                alt=""
                className="h-full mt-9 lg:h-full w-full sm:w-auto mb-6 object-contain"
              />
            )}
            <LazyLoadImage
              src={headerImg.length < 0 ? drop : headerImg[0]}
              alt=""
              effect="blur"
              className="h-full min-h-[224px] min-w-[700px] lg:h-full w-full sm:w-auto self-center object-contain"
            />
            {!company?.customApps && (
              <img
                src={kanan}
                alt=""
                className="h-full lg:h-full w-full sm:w-auto mb-6 object-contain"
              />
            )}
          </div>
        </div>
      </div>
    </div>
    // <div className="stats">
    //   <div
    //     style={{
    //       backgroundColor: customApp?.app_accent_color
    //         ? customApp?.app_accent_color
    //         : "#453BD0",
    //     }}
    //     className="flex justify-between mx-auto bg-gradient-to-l  h-80"
    //   >
    //     <div className="mb-8 pt-8">
    //       {
    //         company?.customApps ?
    //         <h1 className="font-semibold text-base text-white font-montserrat ml-8">
    //           {customApp?.app_display_name}
    //         </h1> :
    //         <img src={logo} alt="" className="h-8 lg:h-8 ml-8" />
    //       }
    //       <img
    //         src={kiri}
    //         alt=""
    //         className="h-full mt-9 lg:h-full w-full sm:w-auto mb-6 object-contain"
    //       />
    //     </div>
    //     <Navbar
    //       item={"Home"}
    //       color={customApp?.app_accent_color}
    //       colorsecond={customApp?.app_secondary_accent_color}
    //     />
    //     <div className="mb-8 pt-8 ">
    //       <ul className="flex justify-end mr-8">
    //         {/* <li>
    //           <a
    //             href="#"
    //             aria-label="Home"
    //             title="Home"
    //             className="inline-flex items-center"
    //           >
    //             <img src={notif} alt="" className="h-8 lg:h-8" />
    //           </a>
    //         </li> */}
    //         <li>
    //           <div
    //             onClick={() => navigate("/profile")}
    //             aria-label="Company"
    //             title="Company"
    //             className="inline-flex items-center cursor-pointer"
    //           >
    //             <img
    //               src={getProfileImage}
    //               alt=""
    //               className="w-10 h-10 object-cover rounded-full"
    //             />
    //           </div>
    //         </li>
    //       </ul>
    //       <img
    //         src={kanan}
    //         alt=""
    //         className="h-full lg:h-full w-full sm:w-auto mb-6 object-contain"
    //       />
    //     </div>
    //   </div>
    // </div>
  );
}

export function StatsMutation() {
  const navigate = useNavigate();
  const [statistics, setStatistics] = useState(null);
  const [headerImg, setHeaderImg] = useState<any[]>([]);

  const env = Config.BaseUrlDev;
  const user: User = useAppSelector((state) => state.user.user);
  let company: any = JSON.parse(String(localStorage.getItem("company")));
  const getProfileImage = useMemo(() => {
    if (user?.photoUrl == "") {
      return userweb;
    }
    return env + "main_a/image/get/" + user?.photoUrl + "/pas";
  }, [user]);

  useEffect(() => {
    // axios.get("https://teamhnm.org/api").then((res, err) => {
    //   setStatistics(res.data.data);
    // });
  }, [statistics !== null]);

  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );

  function getheaderImg() {
    let a: any = [];

    getIconApps(
      customApp?.company_id,
      customApp?.app_desktop_background_header_url
    ).then((res) => {
      a.push(showSvg(res.data));
    });

    setHeaderImg(a);
  }

  useEffect(() => {
    getheaderImg();
  }, []);
  return (
    <div id="stats">
      <div className="">
        <div
          style={{
            backgroundColor: customApp?.app_accent_color
              ? customApp?.app_accent_color
              : "#453BD0",
          }}
          className="flex flex-col w-full overflow-hidden"
        >
          <div className="flex w-full justify-between mx-auto bg-gradient-to-l">
            <div className="mb-8 pt-8">
              {company?.customApps ? (
                <h1
                  className={`font-semibold text-base font-montserrat ml-8 ${
                    isDarkColor(customApp?.app_accent_color)
                      ? "text-white"
                      : "text-black"
                  }`}
                >
                  {customApp?.app_display_name}
                </h1>
              ) : (
                <img src={logo} alt="" className="h-8 lg:h-8 ml-8" />
              )}
            </div>
            <Navbar
              item={"Home"}
              color={customApp?.app_accent_color}
              colorsecond={customApp?.app_secondary_accent_color}
            />
            <div className="mb-8 pt-8 ">
              <ul className="flex justify-end mr-8">
                <li>
                  <div
                    onClick={() => navigate("/profile")}
                    aria-label="Company"
                    title="Company"
                    className="inline-flex items-center cursor-pointer"
                  >
                    <img
                      src={getProfileImage}
                      alt=""
                      className="w-10 h-10 object-cover rounded-full"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div
            className={`flex w-full h-1/2 md:w-64 md:h-48 lg:w-full lg:h-56 ${
              company?.customApps
                ? "justify-center items-center"
                : "justify-between"
            }`}
          >
            {!company?.customApps && (
              <img
                src={kiri}
                alt=""
                className="h-full mt-9 lg:h-full w-full sm:w-auto mb-6 object-contain"
              />
            )}
            <LazyLoadImage
              src={headerImg.length < 0 ? drop : headerImg[0]}
              alt=""
              effect="blur"
              className="h-full min-h-[224px] min-w-[700px] lg:h-full w-full sm:w-auto self-center object-contain"
            />
            {!company?.customApps && (
              <img
                src={kanan}
                alt=""
                className="h-full lg:h-full w-full sm:w-auto mb-6 object-contain"
              />
            )}
          </div>
        </div>
      </div>
    </div>
    // <div id="stats">
    //   <div className="">
    //     <div
    //       style={{
    //         backgroundColor: customApp?.app_accent_color
    //           ? customApp?.app_accent_color
    //           : "#453BD0",
    //       }}
    //       className="flex justify-between mx-auto bg-gradient-to-l h-80"
    //     >
    //       <div className="mb-8 pt-8">
    //         {
    //           company?.customApps ?
    //           <h1 className="font-semibold text-base text-white font-montserrat ml-8">
    //             {customApp?.app_display_name}
    //           </h1> :
    //           <img src={logo} alt="" className="h-8 lg:h-8 ml-8" />
    //         }
    //         <img
    //           src={kiri}
    //           alt=""
    //           className="h-full lg:h-full w-full sm:w-auto mb-6 object-contain"
    //         />
    //       </div>
    //       <Navbar
    //         item={"Home"}
    //         color={customApp?.app_accent_color}
    //         colorsecond={customApp?.app_secondary_accent_color}
    //       />
    //       <div className="mb-8 pt-8 ">
    //         <ul className="flex justify-end mr-8">
    //           {/* <li>
    //             <a
    //               href="#"
    //               aria-label="Home"
    //               title="Home"
    //               className="inline-flex items-center"
    //             >
    //               <img src={notif} alt="" className="h-8 lg:h-8" />
    //             </a>
    //           </li> */}
    //           <li>
    //             <div
    //               onClick={() => navigate("/profile")}
    //               aria-label="Company"
    //               title="Company"
    //               className="inline-flex items-center cursor-pointer"
    //             >
    //               <img
    //                 src={getProfileImage}
    //                 alt=""
    //                 className="w-10 h-10 object-cover rounded-full"
    //               />
    //             </div>
    //           </li>
    //         </ul>
    //         <img
    //           src={kanan}
    //           alt=""
    //           className="h-full lg:h-full w-full sm:w-auto mb-6 object-contain"
    //         />
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
}

export function StatsInformasi() {
  const navigate = useNavigate();
  const [statistics, setStatistics] = useState(null);
  const [headerImg, setHeaderImg] = useState<any[]>([]);

  const env = Config.BaseUrlDev;
  const user: User = useAppSelector((state) => state.user.user);
  let company: any = JSON.parse(String(localStorage.getItem("company")));
  const getProfileImage = useMemo(() => {
    if (user?.photoUrl == "") {
      return userweb;
    }
    return env + "main_a/image/get/" + user?.photoUrl + "/pas";
  }, [user]);

  useEffect(() => {
    // axios.get("https://teamhnm.org/api").then((res, err) => {
    //   setStatistics(res.data.data);
    // });
  }, [statistics !== null]);

  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );

  function getheaderImg() {
    let a: any = [];

    getIconApps(
      customApp?.company_id,
      customApp?.app_desktop_background_header_url
    ).then((res) => {
      a.push(showSvg(res.data));
    });

    setHeaderImg(a);
  }

  useEffect(() => {
    getheaderImg();
  }, []);
  return (
    <div id="stats">
      <div className="pb-20">
        <div
          style={{
            backgroundColor: customApp?.app_accent_color
              ? customApp?.app_accent_color
              : "#453BD0",
          }}
          className="flex flex-col w-full overflow-hidden"
        >
          <div className="flex w-full justify-between mx-auto bg-gradient-to-l">
            <div className="mb-8 pt-8">
              {company?.customApps ? (
                <h1
                  className={`font-semibold text-base font-montserrat ml-8 ${
                    isDarkColor(customApp?.app_accent_color)
                      ? "text-white"
                      : "text-black"
                  }`}
                >
                  {customApp?.app_display_name}
                </h1>
              ) : (
                <img src={logo} alt="" className="h-8 lg:h-8 ml-8" />
              )}
            </div>
            <Navbar
              item={"Informasi"}
              color={customApp?.app_accent_color}
              colorsecond={customApp?.app_secondary_accent_color}
            />
            <div className="mb-8 pt-8 ">
              <ul className="flex justify-end mr-8">
                <li>
                  <div
                    onClick={() => navigate("/profile")}
                    aria-label="Company"
                    title="Company"
                    className="inline-flex items-center cursor-pointer"
                  >
                    <img
                      src={getProfileImage}
                      alt=""
                      className="w-10 h-10 object-cover rounded-full"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div
            className={`flex w-full h-1/2 md:w-64 md:h-48 lg:w-full lg:h-56 ${
              company?.customApps
                ? "justify-center items-center"
                : "justify-between"
            }`}
          >
            {!company?.customApps && (
              <img
                src={kiri}
                alt=""
                className="h-full mt-9 lg:h-full w-full sm:w-auto mb-6 object-contain"
              />
            )}
            <LazyLoadImage
              src={headerImg.length < 0 ? drop : headerImg[0]}
              alt=""
              effect="blur"
              className="h-full min-h-[224px] min-w-[700px] lg:h-full w-full sm:w-auto self-center object-contain"
            />
            {!company?.customApps && (
              <img
                src={kanan}
                alt=""
                className="h-full lg:h-full w-full sm:w-auto mb-6 object-contain"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
